export default "__VITE_PUBLIC_ASSET__0bd70635__"